// The shapes this module's API returns and accepts.

import { z } from "zod";

export interface SessionUser {
  authenticated: boolean;
}

// The running server's own version/commit, shown on the Settings "About" card.
export interface AboutInfo {
  version: string;
  commit: string | null;
}

// ---- auth ----
export const loginSchema = z.object({
  password: z.string().min(1, "Password is required"),
});

export const dateStr = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD");

export const deleteIdsSchema = z.object({
  ids: z.array(z.coerce.number().int().positive()).min(1),
});

export const updateDisplayTimezoneSchema = z.object({
  // Must be a zone `Intl` actually accepts, not merely a non-empty string: the
  // inspiration service derives the user's calendar day from this, and a bogus
  // value would throw RangeError inside Intl on a hot read path.
  timezone: z
    .string()
    .min(1)
    .max(64)
    .refine((tz) => {
      try {
        new Intl.DateTimeFormat("en-CA", { timeZone: tz });
        return true;
      } catch {
        return false;
      }
    }, "Unknown time zone"),
});
